<script>
    import axios from 'axios';
    import trans from '../mixins/trans';

    export default {
        name: "TrainingWatchlistButton",

        mixins: [
            trans
        ],

        props: [
            'defaultOnWatchlist',
            'route',
            'training',
            'trainingId',
        ],

        data() {
            return {
                onWatchlist: this.defaultOnWatchlist,
            };
        },

        computed: {
            isOnWatchlist() {
                return this.onWatchlist === true || this.onWatchlist === '1';
            }
        },

        methods: {
          addToWatchlist() {

            let self = this;

            axios.post(this.route)
                .then((response) => {
                  this.onWatchlist = true;



                  window.app.$refs.watchlist.update();
                  window.app.$refs.miniWatchlist.update();
                  
                  window.dataLayer.push({
                    'event': 'addToWatchlist',
                    'training': self.training,
                    'trainingId': [parseFloat(self.trainingId)],
                    'source_of_request': 'detail_page',
                  });


                  this.$notifications.success(this.__("The training was added to your watchlist.", {
                    'training': response.data.training.display_title
                  }), [
                    {
                      text: this.__('Watchlist'),
                      classes: 'btn btn-default',
                      callback: () => {
                        document.location.href = response.data.watchlist;
                      }
                    }
                  ]);
                })
          }
        }
    }
</script>

<style scoped>

</style>